var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"disabled":_vm.isChatReady,"content":"Please wait while the chat loads"}},[_c('a',{staticClass:"chat-icon no-results-tour-1",class:{
      'chat-icon-disabled': !_vm.isChatReady,
      'active': _vm.NoResultsTour.currentStep === 1
    },on:{"click":_vm.toggleChatWidget}})])}
var staticRenderFns = []

export { render, staticRenderFns }